import React, { useEffect, useCallback, useRef, useState } from "react";
import "./CustomerPaymentLedger.css";
import { Select, DatePicker, Form, Table, Button, Spin } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getGender } from "../../redux/actions/gender.action";
import { getAllCompany } from "../../redux/actions/companyAccess";
import { getAllScmBrand } from "../../redux/actions/scmBrand.action";
import { getCustomerType } from "../../redux/actions/customerType.action";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getCustomerPaymentReport } from "../../redux/actions/customerPayment.action";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import csv from "../../assets/images/csv.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ExcelJS from "exceljs";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { createInvoicePdfDownload } from "../../redux/actions/invoiceEmail.action";
import notification from "../../utils/notification";

const { Option } = Select;
const dateFormatList = ["MM/DD/YYYY"];

const CustomerPaymentLedger = ({ token }) => {
  TabTitle("Customer Ledger")
  const userName = ReadCookie("name");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const focusInput = useRef(null);
  const tableRef = useRef(null);
  const [select, setSelect] = useState("All");
  const [loader, setLoader] = useState(false);
  const [customerList, setCutomerList] = useState([]);
  const [customerId, setCutomerId] = useState([]);
  const [excelData, setExcelData] = useState([])
  const [selectedRows, setSelectedRows] = useState([]);
  const {
    gender,
    region,
    companyAll,
    scmBrand,
    customerForms,
    getBussinessDashboardReducer,
    customerPayment,
    invoicePdf
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const [customer, setCustomer] = useState("All");
  const { submited } = useParams();



  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);
  let rbalance = 0;

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let customer_id = query.get("customer_id");
  let customer_name = query.get("customer_name");
  let till_Date = query.get("till_Date");

  useEffect(() => {

    let values = {
      customer_id: customer_id,
      from_date: "01-01-2010",
      to_date: till_Date,
      status: "U",
      customer_name: customer_name
    };

    form.setFieldsValue({
      customer_id: values.customer_id,
      from_date: moment(values.from_date),
      to_date: values.to_date ? moment(values.to_date, "MM-DD-YYYY") : moment().endOf("year"),
      status: "U"
    });
    if (customer_id) {
      setLoader(true)
      dispatch(getCustomerPaymentReport(token, values)).then((res) => {

        let filterData = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id != "0";
        })

        let filterZeroId = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id == "0";
        })


        setCutomerId(filterZeroId)
        setCutomerList(filterData)
        setLoader(false);
        downloadExcelFileData(filterData, filterZeroId);

        dispatch(loadCustomers(token, null, null, null, null, null, customer_name, null, null, null, null, null, null, null, null, null, null, null, null)).then(
          (res) => {
            if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
              setCustomer(res?.payload?.data);
            }
          }
        );
      })
    }
  }, [customer_id])

  const onFinish = async (e) => {
    setLoader(true)
    await form.validateFields().then((values) => {
      dispatch(getCustomerPaymentReport(token, values)).then((res) => {

        let filterData = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id != "0";
        })

        let filterZeroId = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id == "0";
        })


        setCutomerId(filterZeroId)
        setCutomerList(filterData)
        setLoader(false);
        downloadExcelFileData(filterData, filterZeroId);
      })
    });
  };

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(getAllCompany(token));
    dispatch(getAllScmBrand(token));
    dispatch(getCustomerType(token));
  }, [dispatch, menuId, token]);


  const handlePrint = () => {
    const css = '@page { margin-top: 25px; margin-bottom: 25px; margin-right: 25px}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };

  // console.log("first", res?.payload?.data?.filter(
  //           (elem) => elem.invoice_header_id == "0"
  //         )?.[0]?.credit_balance)


  function downloadExcelFileData(data, customerId) {
    setExcelData(
      data.map((v) => {
        return {
          "Invoice#": v.invoice_header_no,
          "Invoice Date": moment(v.invoice_date).format("MM-DD-YYYY"),
          "PO Number": v.po_number,
          "Term": v.term_name,
          "Invoice Amount": `$ ${v.invoice_amount}`,
          "Payment": v.amount_paid,
          "RTV Credit": `$ ${v.note_amount_us}`,
          "Credit Taken": v.credituse,
          "Credit Applied": v.payment_adjustment,
          "Refund": v.refund_amount,
          "Balance": `$ ${v.balance}`,
          "R.Balance": `$ ${v.running_balance}`,
          "Status": v.status,
          "Days": v.daysdiff,
          "Due Date": moment(v.due_date).format("MM-DD-YYYY"),
          "Gender": v.gender_name,
        };
      })
        .concat([
          {}, // optional empty row

          {
            "Invoice#": "Other Credit",
            "Invoice Date": numeral(customerId?.[0]?.credit_balance || 0).format("$0,0,0"),
            "PO Number": "Unapplied Amount",
            "Term": numeral(customerId?.[0]?.unapplied_amount || 0).format("$0,0,0"),
          },
        ])
    );
  }


  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Define columns + currency formatting
    worksheet.columns = [
      { header: 'Invoice#', key: 'invoice_header_no', width: 35 },
      { header: 'Invoice Date', key: 'invoice_date', width: 35 },
      { header: 'PO Number', key: 'po_number', width: 15 },
      { header: 'Term', key: 'term_name', width: 30 },
      { header: 'Invoice Amount', key: 'invoice_amount', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'Payment', key: 'amount_paid', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'RTV Credit', key: 'note_amount_us', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'Credit Taken', key: 'credituse', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'Credit Applied', key: 'payment_adjustment', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'Refund', key: 'refund_amount', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'Balance', key: 'balance', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'R.Balance', key: 'r_balance', width: 15, style: { numFmt: '"$"#,##0.00' } },
      { header: 'Status', key: 'status', width: 15 },
      { header: 'Days', key: 'daysdiff', width: 15 },
      { header: 'Due Date', key: 'due_date', width: 15 },
      { header: 'Gender', key: 'gender_name', width: 15 },
    ];

    // Filter valid invoices
    const filterData = customerPayment?.payload?.data?.filter((elem) => elem.invoice_header_id != "0") || [];
    const filterZeroId = customerPayment?.payload?.data.filter((elem) => elem.invoice_header_id == "0") || []

    // Totals
    let totalInvoiceAmount = 0;
    let totalCreditNote = 0;
    let totalPayment = 0;
    let totalAdjustment = 0;
    let totalRefund = 0;
    let totalCredit = 0;
    let totalBalance = 0;

    // Add rows
    filterData.forEach((item) => {
      worksheet.addRow({
        invoice_header_no: item.invoice_header_no,
        invoice_date: moment(item.invoice_date).format("MM-DD-YYYY"),
        po_number: item.po_number,
        term_name: item.term_name,
        invoice_amount: Number(item.invoice_amount) || 0, // 👈 real number
        amount_paid: Number(item.amount_paid) || 0,
        note_amount_us: Number(item.note_amount_us) || 0,
        credituse: Number(item.credituse) || 0,
        payment_adjustment: Number(item.payment_adjustment) || 0,
        refund_amount: Number(item.refund_amount) || 0,
        balance: Number(item.balance) || 0,
        r_balance: Number(item.r_balance) || 0,
        status: item.status,
        daysdiff: item.daysdiff,
        due_date: moment(item.due_date).format("MM-DD-YYYY"),
        gender_name: item.gender_name,
      });

      totalInvoiceAmount += Number(item.invoice_amount) || 0;
      totalPayment += Number(item.amount_paid) || 0;
      totalCreditNote += Number(item.note_amount_us) || 0;
      totalCredit += Number(item.credituse) || 0;
      totalAdjustment += Number(item.payment_adjustment) || 0;
      totalRefund += Number(item.refund_amount) || 0;
      totalBalance += Number(item.balance) || 0;
    });

    // Add totals row
    const totalRow = worksheet.addRow({
      invoice_header_no: `Other Credit : $${filterZeroId?.[0]?.credit_balance ?? 0}`,
      invoice_date: `Unapplied Amount : $${filterZeroId?.[0]?.unapplied_amount ?? 0}`,
      term_name: 'Total',
      invoice_amount: totalInvoiceAmount,
      amount_paid: totalPayment,
      note_amount_us: totalCreditNote,
      credituse: totalCredit,
      payment_adjustment: totalAdjustment,
      refund_amount: totalRefund,
      balance: totalBalance,
    });

    // Make total row bold
    totalRow.font = { bold: true };

    // Save workbook
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const filename = 'Customer-Payment-ledger.xlsx';
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } catch (error) {
      console.error(error);
    }
  };




  function generatePDF() {
    var doc = new jsPDF({
      orientation: "landscape",  // ya "portrait"
      unit: "mm",                // px, pt, mm, in
      format: "a4"               // page size
    });

    var columns = ["Invoice#", "Invoice Date", "PO Number", "Term", "Invoice Amount", "Payment", "RTV Credit", "Credit Taken", "Credit Applied", "Refund", "Balance", "R.Balance", "Status	", "Days", "Due Date", "Gender"];
    var rows = [];

    var customerName = customerPayment?.payload?.data[0]?.customer_name || "Unknown Customer";

    doc.setFontSize(10);
    doc.text(`Customer Name: ${customerName}`, 15, 10);

    var yOffset = 7;

    doc.autoTable({
      startY: yOffset,
      body: rows,
      styles: { fontSize: 6 },
    });

    let filteredData = customerPayment?.payload?.data.filter((elem) => {
      return elem.invoice_header_id != "0";
    });


    filteredData.forEach(item => {
      var row = [item.invoice_header_no, moment(item.invoice_date).format("MM-DD-YYYY"), item.po_number, item.term_name, "$" + numeral(item.invoice_amount).format("0,00.00"), "$" + numeral(item.amount_paid).format("0,00.00"), "$" + numeral(item.note_amount_us).format("0,00.00"), "$" + numeral(item.credituse).format("0,00.00"), "$" + numeral(item.payment_adjustment).format("0,00.00"), "$" + numeral(item.refund_amount).format("0,00.00"), "$" + numeral(item.balance).format("0,00.00"), "$" + numeral(item.r_balance).format("0,00.00"), item.status, item.daysdiff, moment(item.due_date).format("MM-DD-YYYY"), item.gender_name];
      rows.push(row);
    });

    const total_invoice_amount = filteredData.reduce((acc, item, index) => acc + parseFloat(item.invoice_amount), 0)
    const totalPayment = filteredData.reduce((acc, item, index) => acc + parseFloat(item.amount_paid), 0)
    const total_note_amount = filteredData.reduce((acc, item, index) => acc + parseFloat(item.note_amount_us), 0)
    const totalCredit = filteredData.reduce((acc, item, index) => acc + parseFloat(item.credituse), 0)
    const totalAdjustment = filteredData.reduce((acc, item, index) => acc + parseFloat(item.payment_adjustment), 0)
    const totalRefund = filteredData.reduce((acc, item, index) => acc + parseFloat(item.refund_amount), 0)
    const total_balance = filteredData.reduce((acc, item, index) => acc + parseFloat(item.balance), 0)

    rows.push([" ", " ", " ", "Total: ", "$" + total_invoice_amount.toLocaleString("en-US"), "$" + totalPayment.toLocaleString("en-US"), "$" + total_note_amount.toLocaleString("en-US"), "$" + totalCredit.toLocaleString("en-US"), "$" + totalAdjustment.toLocaleString("en-US"), "$" + totalRefund.toLocaleString("en-US"), "$" + total_balance.toLocaleString("en-US")])

    doc.autoTable({
      head: [columns],
      body: rows,
      styles: { fontSize: 6 },
    })

    doc.save("Customer-Payment-ledger.pdf");
  }


  const column = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "Invoice#",
      dataIndex: "invoice_header_no",
      key: "invoice_header_no",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      render: (text, record) => {
        return moment(record.invoice_date).format("MM-DD-YYYY")
      }
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      width: 150
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
    },
    {
      title: "Invoice Amount",
      dataIndex: "invoice_amount",
      key: "invoice_amount",
      render: (text, record) => {
        return "$" + numeral(record.invoice_amount).format("0,00.00")
      }
    },

    // {
    //   title: "Payment/Adjustment",
    //   dataIndex: "payment_us",
    //   key: "payment_us",
    //   render: (text, record) => (
    //     <Link
    //       style={{ padding: "10px", textDecoration: "none" }}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       to={{ pathname: `/customer-payment-report`, search: `?invoice_id=${record?.invoice_header_id}` }}
    //     >
    //       {"$" + numeral(record.payment_us).format("0,00.00")}
    //     </Link>
    //   )
    // },
    // {
    //   title: "Refund/Credit Use",
    //   dataIndex: "refund_amount_us",
    //   key: "refund_amount_us",
    //   render: (text, record) => (
    //     <Link
    //       style={{ padding: "10px", textDecoration: "none" }}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       to={{ pathname: `/customer-refund-report`, search: `?invoice_id=${record?.invoice_header_id}` }}
    //     >
    //       {"$" + numeral(record.refund_amount_us).format("0,00.00")}
    //     </Link>
    //   )
    // },
    {
      title: "Payment",
      dataIndex: "amount_paid",
      key: "amount_paid",
      render: (text, record) => (
        <Link
          style={{ padding: "10px", textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          to={{ pathname: `/customer-payment-report`, search: `?invoice_id=${record?.invoice_header_id}` }}
        >
          {"$" + numeral(record.amount_paid).format("0,00.00")}
        </Link>
      )
    },
    {
      title: "RTV Credit",
      dataIndex: "note_amount_us",
      key: "note_amount_us",
      render: (text, record) => {
        return "$" + numeral(record.note_amount_us).format("0,00.00")
      }
    },
    {
      title: "Credit Taken",
      dataIndex: "credituse",
      key: "credituse",
      render: (text, record) => (
        <Link
          style={{ padding: "10px", textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          to={{ pathname: `/customer-credit-report`, search: `?invoice_id=${record?.invoice_header_id}` }}
        >
          {"$" + numeral(record.credituse).format("0,00.00")}
        </Link>
      )
    },
    {
      title: "Credit Applied",
      dataIndex: "payment_adjustment",
      key: "payment_adjustment",
      render: (text, record) => (
        <Link
          style={{ padding: "10px", textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          to={{ pathname: `/customer-adjustment-report`, search: `?invoice_id=${record?.invoice_header_id}` }}
        >
          {"$" + numeral(record.payment_adjustment).format("0,00.00")}
        </Link>
      )
    },
    {
      title: "Refund",
      dataIndex: "refund_amount",
      key: "refund_amount",
      render: (text, record) => (
        <Link
          style={{ padding: "10px", textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          to={{ pathname: `/customer-refund-report`, search: `?invoice_id=${record?.invoice_header_id}` }}
        >
          {"$" + numeral(record.refund_amount).format("0,00.00")}
        </Link>
      )
    },

    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      render: (text, record) => {
        return "$" + numeral(record.balance).format("0,00.00")
      }
    },
    {
      title: "R.Balance",
      dataIndex: "r_balance",
      key: "r_balance",
      render: (text, record) => {
        return "$" + numeral(record.r_balance).format("0,00.00")
      }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render(text, record) {
        return {
          props: {
            style: { color: text === "Paid" ? "green" : "red" }
          },
          children: <div>{text}</div>
        };
      }
    },
    {
      title: "Days",
      dataIndex: "daysdiff",
      key: "daysdiff",
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: (text, record) => {
        return moment(record.due_date).format("MM-DD-YYYY")
      }
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
    },
  ];

  const total_invoice_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.invoice_amount), 0)
  const total_note_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.note_amount_us), 0)
  // const total_payment_us = customerList.reduce((acc, item, index) => acc + parseFloat(item.payment_us), 0)
  // const total_Adj_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.refund_amount_us), 0)
  const total_balance = customerList.reduce((acc, item, index) => acc + parseFloat(item.balance), 0)

  const total_amount_paid = customerList.reduce((acc, item, index) => acc + parseFloat(item.amount_paid), 0)
  const total_adjustment = customerList.reduce((acc, item, index) => acc + parseFloat(item.payment_adjustment), 0)
  const total_refund_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.refund_amount), 0)
  const total_credit_use = customerList.reduce((acc, item, index) => acc + parseFloat(item.credituse), 0)


  let result =
    selectedRows.length > 0 &&
    selectedRows?.reduce(function (r, a) {
      r[a.customer_id] = r[a.customer_id] || [];
      r[a.customer_id].push(a);
      return r;
    }, Object.create(null));

  const selectedRow = result ? Object.values(result) : [];


  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };


  const downloadInvoice = () => {
    selectedRow.map((resp) => {
      dispatch(createInvoicePdfDownload(token, resp)).then((res) => {
        if (res?.type === "GET_PDF_DOWNLOAD_SUCCESS") {
          const pdfBlob = new Blob([res?.payload], { type: "application/pdf" });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.download = "InvoiceReport.pdf";
          link.click();
          URL.revokeObjectURL(pdfUrl);
          notification("success", "Invoice Downloaded Successfully");
          setSelectedRows([]);
          setCutomerList([]);
        }
      });
    })

  }





  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className="report-wrapper-main header_class business_class">
            <div className="row justify-content-between pb-2 ledger_print_ar">
              <div className="col-3 d-flex align-items-start  box-space">
                <div className="logobrand">
                  <img id="ImgLogo" alt="logo" src={logo} />
                </div>
              </div>

              <div className="col-4 box-space right-content-header text-right pb-0">
                <div className=" d-flex justify-content-end">
                  <div className=" d-flex printing_class mr-8">
                    <div className="print_icon printing_class">
                      <i
                        onClick={handlePrint}
                        id="Image1"
                        title="Print"
                        alt="Print"
                        src={btnPrint}
                        className="fa-solid fa-print"
                      ></i>
                    </div>
                    <div className="print_icon printing_class" >
                      <CSVLink
                        filename={"Customer-Payment-ledger.csv"}
                        data={excelData}
                        onClick={() => {
                        }}
                      >
                        <input
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}


                          style={{ borderWidth: "0px", height: "14px" }}
                        />
                      </CSVLink>
                    </div>
                    <div className="print_icon printing_class" >
                      <input
                        type="image"
                        name="ImgExcel"
                        alt="Export to Excel"
                        id="ImgExcel"
                        title="Export to Excel"
                        src={xlsx}
                        onClick={exportToExcel}

                        style={{ borderWidth: "0px", height: "14px" }}
                      />
                    </div>
                    <div className="print_icon printing_class" >
                      <input
                        type="image"
                        name="ImgPDF"
                        alt="Export to PDF"
                        id="ImgPDF"
                        title="Export to PDF"
                        src={pdf}
                        onClick={generatePDF}

                        style={{ borderWidth: "0px", height: "18px" }}
                      />
                      {/* <button onClick={() => generatePDF()}>Generate PDF</button> */}
                    </div>
                  </div>
                  <span style={{ fontWeight: "bolder" }}>
                    Customer Payment Ledger
                    <br />

                    <div className="printing_class123">
                      Rpt # 489
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            {/* Filters Table */}
            <div className="row ledger_print_ar">
              <div className="col business_header">
                <Form form={form} name="control-hooks" onFinish={onFinish}>
                  <div className="main_form row">

                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          From:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="from_date"
                          // initialValue={moment().startOf('year')}
                          >
                            <DatePicker
                              size="small"
                              // defaultValue={moment().format("MM-DD-YYYY")}
                              format={dateFormatList}
                              className={"input-width"}

                            />
                          </Form.Item>
                        </div>
                      </div>

                    </div>
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          To:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="to_date"
                            initialValue={moment().endOf('year')}
                          >
                            <DatePicker
                              size="small"
                              format={dateFormatList}
                              className={"input-width"}

                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="main_form row">

                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Customer:</label>
                        <div className=" w-100">
                          <Form.Item
                            name="customer_id"
                            rules={[
                              {
                                required: true,
                                message: "Customer is Required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"
                              className={"select_Inputs"}
                              loading={customerForms.loading}

                              size="small"
                              onSearch={(value) => {
                                optimizedFn(value);
                              }}
                              ref={focusInput}
                              value={customer}
                              filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {customerForms?.payload?.data.map((item) => {
                                return (
                                  <Option
                                    key={item.customer_id}
                                  >
                                    {`${item.customer_name}`}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Status:</label>
                        <div className=" w-100">
                          <Form.Item
                            className=" w-100"
                            name="status"
                            initialValue={"All"}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"

                              className="select_Inputs"

                              defaultValue={
                                submited ? form.getFieldValue().status : "All"
                              }
                              size="small"

                            >
                              <Option key={"All"} value={"All"}>
                                All
                              </Option>
                              <Option key={"P"} value={"P"}>
                                Paid
                              </Option>
                              <Option key={"U"} value={"U"}>
                                Unpaid
                              </Option>
                              {/* <Option key={"E"} value={"E"}>
                                Excess Paid
                              </Option> */}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div>
                        <Button
                          htmlType="submit"
                          type="primary"
                          className="submit-btn-btm "
                        >
                          Submit
                        </Button>
                      </div>
                      {
                        selectedRows.length > 0 ? (
                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
                            <Button
                              disabled={invoicePdf.loading ? true : false}
                              type="primary" onClick={downloadInvoice}>
                              {invoicePdf.loading ? <><Spin size="small" className="customer_payment_ledger_btn_loader mr-1" /> Download Pdf ({selectedRows.length})</> : `Download Pdf (${selectedRows.length})`}
                            </Button>
                          </div>
                        ) : null
                      }
                    </div>
                  </div>
                </Form>
              </div>
            </div>
            {/* Render Data Table */}
          </div>
          <div className="table_content customer_ledger_table_content ledger_print omsTable"

            style={{ maxWidth: '1500px' }}
          >
            <div className="">
              {customerPayment ? (
                customerPayment?.payload?.data?.length > 0 ? (
                  (
                    <div className="data_Table ledger_print_ar">
                      <div >
                        <div

                          style={{ margin: "0 auto", paddingTop: "10px" }}
                        >
                          <table id="Table1" cellPadding="3" cellSpacing="0" align="center" className="tablestyleControls" style={{ fontSize: "10px" }}>
                            <tbody>
                              <tr>
                                <td className="font_weight">
                                  Name :
                                </td>
                                <td style={{ width: "106px" }} colSpan={2}>
                                  <b>
                                    {customerPayment?.payload?.data[0].customer_name}
                                  </b>
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td className="font_weight">
                                  Address :
                                </td>
                                <td colSpan={2}>
                                  <b>
                                    {customerPayment?.payload?.data[0].address_1}
                                  </b>
                                </td>
                                <td></td>
                                <td className="font_weight">
                                  Balance :
                                </td>
                                <td colSpan={2}>
                                  <b className="font_weight">
                                    ${numeral(total_balance).format("0,00,0")}
                                  </b>
                                </td>
                              </tr>
                              {/* <tr>
                                <td className="no-border-btm font_weight" style={{ width: "70px" }}>
                                  City :
                                </td>
                                <td style={{ width: "263px" }}>
                                  <b>
                                    {customerPayment?.payload?.data[0].city_name}
                                  </b>
                                </td>
                                <td style={{ width: "126px" }} className="font_weight">
                                  State :
                                </td>
                                <td style={{ width: "119.6px" }} >
                                  <b>
                                    {customerPayment?.payload?.data[0].state_name}
                                  </b>
                                </td>
                              </tr> */}
                              <tr>
                                <td className="font_weight">
                                  City :
                                </td>
                                <td>
                                  <b>
                                    {customerPayment?.payload?.data[0].city_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight" >
                                  State :
                                </td>
                                <td style={{ width: "50px" }}>
                                  <b>
                                    {customerPayment?.payload?.data[0].state_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Other Credit :
                                </td>
                                <td>
                                  <b className="font_weight">
                                    ${numeral(customerId && customerId[0]?.credit_balance).format("0,00,0")}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="font_weight">
                                  Country :
                                </td>
                                <td>
                                  <b>
                                    {customerPayment?.payload?.data[0].country_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Zip Code :
                                </td>
                                <td style={{ width: "50px" }}>
                                  <b>
                                    {customerPayment?.payload?.data[0].zip_code}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Unapplied Amount :
                                </td>
                                <td >
                                  <b className="font_weight">
                                    ${numeral(customerId && customerId[0]?.unapplied_amount).format("0,00,0")}
                                  </b>
                                </td>
                              </tr>
                            </tbody >
                          </table >
                        </div>
                      </div>
                    </div>
                  )

                ) : <></>) : <></>}
              <Table
                className="
                
                test04 mt-3 sales_report_res_table_intransit ledger_print omsTable hide_selection"
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                headerClassName='abc'
                dataSource={customerList?.length > 0 ? customerList : []}
                columns={column}
                loading={customerPayment?.loading}
                rowSelection={{
                  ...rowSelection,
                  hideSelectAll: true,
                }}
                rowKey="invoice_header_id"
                scroll={{
                  x: 'max-content',
                  // y: 450,
                }}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 100,
                  pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                }}
                summary={(pageData) => {
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell >Other Credit : ${numeral(customerId && customerId[0]?.credit_balance).format("0,00,0")}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell >Unapplied Amount : ${numeral(customerId && customerId[0]?.unapplied_amount).format("0,00,0")}</Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            ${total_invoice_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_memo_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            ${total_amount_paid.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            ${total_note_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            ${total_credit_use.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            ${total_adjustment.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            ${total_refund_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_refund_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_credit_note_apply.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_memo_apply.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            ${total_balance.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_running_balance.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell></Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerPaymentLedger;
